<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 开票审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="3">已开票</Radio>
                                            <Radio :label="2">驳回申请</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 3">
                                    <FormItem label="发票附件">
                                        <Input v-model="Forms.invoice_image" disabled>
                                            <template #append>
                                                <div class="f-center">
                                                    <Upload
                                                        :show-upload-list="false"
                                                        :action="upload_url"
                                                        :headers = "{'token': $store.state.token}"
                                                        :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                                        :max-size="50 * 1024"
                                                        :on-success="handleSuccess"
                                                        :on-format-error="handleFormatError"
                                                        :on-exceeded-size="handleMaxSize">
                                                        <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                                    </Upload>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDelete" class="text-danger"><Icon type="md-trash" />删除</a>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDownload(Forms.invoice_image)" class="text-violet"><Icon type="md-download" />下载</a>
                                                </div>
                                            </template>
                                        </Input>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 2">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 发票信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="零星项目：">
                                    {{detail.project_name || '-'}}
                                </Description>
                                <Description term="甲方：" v-if="kind === 1">
                                    {{detail.customer_name ?? '-'}}
                                </Description>
                                <Description term="维保记录：" v-if="kind === 1">
                                    {{detail.maintain_title ?? '-'}}
                                </Description>
                                <Description term="开票公司：">
                                    {{detail.inv_company_name ?? '-'}}
                                </Description>
                                <Description term="发票类型：">
                                    <Tag>{{detail.inv_type_name}}</Tag>
                                </Description>
                                <Description term="开票金额：">
                                    <Tag color="blue">{{detail.inv_money}}</Tag>
                                </Description>
                                <Description term="到账金额：" v-if="kind === 1">
                                    <Tag color="green">{{detail.get_money}}</Tag>
                                </Description>
                                <Description term="发票名称：" v-if="kind === 2">
                                    {{detail.title ?? '-'}}
                                </Description>
                                <Description term="发票抬头：" v-if="kind === 1">
                                    {{detail.inv_head}}
                                </Description>
                                <Description term="发票税号：" v-if="kind === 1">
                                    {{detail.inv_num}}
                                </Description>
                                <Description term="联系电话：" v-if="kind === 1">
                                    {{detail.inv_tel}}
                                </Description>
                                <Description term="发票地址：" v-if="kind === 1">
                                    {{detail.inv_address}}
                                </Description>
                                <Description term="开户银行：" v-if="kind === 1">
                                    {{detail.inv_bank}}
                                </Description>
                                <Description term="银行卡号：" v-if="kind === 1">
                                    {{detail.inv_bank_card}}
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {examineDispersedInvoice, getDispersedInvoiceDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedInvoiceExamine',
    components: {
    },
    props: {
        kind: {
            type: [Number, String],
            default: 1
        }
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '开票审批',
            isBox : false,
            detail: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                invoice_id: '',
                status: '',
                reject_remark: '',
                invoice_image: '',
            },
            Rules : {

            }
        }
    },
    methods: {
      /**
       * 功能：附件删除
       * time: 2026/09/13
       **/
      FileDelete(){
        this.Forms.invoice_image = '';
      },
      /**
       * 功能：附件下载
       * time: 2026/09/13
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         * 功能：上传成功
         * time: 2026/09/13
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.invoice_image = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         * 功能：详情
         * time: 2026/09/13
         **/
        GetDetail(invoice_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedInvoiceDetail(invoice_id).then(e => {
                that.detail = e.data;
                //回填已有发票附件，审批时可重新上传覆盖
                that.Forms.invoice_image = e.data.invoice_image ?? '';
            })
        },
        /**
         * 功能：打开
         * time: 2026/09/13
         **/
        show(invoice_id){
            this.isBox = true;
            if(invoice_id){
                this.Forms.invoice_id = invoice_id;
                this.GetDetail(invoice_id);
            }
        },
        /**
         * 功能：提交
         * time: 2026/09/13
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineDispersedInvoice(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         * 功能：重置
         * time: 2026/09/13
         **/
        FormReset(){
            this.isBox = false;
            this.title = '开票审批';
            this.$refs['Forms'] && this.$refs['Forms'].resetFields();
            this.Forms = {
                invoice_id: '',
                status: '',
                reject_remark: '',
                invoice_image: '',
            };
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
